import { Controller } from "@hotwired/stimulus"
import DirectoryTable from "../lib/directory_table"
import { DateTime } from "luxon"
import { emptyStatePlaceholder } from "./tabulator_helpers"

export default class extends Controller {
  static targets = [
    'usages',
    'table'
  ]

  static values = {
    url: String,
    range: Number,
    tabulatorTable: Object,
  }

  // Match the table's row granularity to the chart: day (30d), week (90d),
  // month (365d).
  periodColumn() {
    switch (Number(this.rangeValue)) {
      case 90:
        return { title: "Week of", outputFormat: "MMM d, yyyy" }
      case 365:
        return { title: "Month", outputFormat: "MMMM yyyy" }
      default:
        return { title: "Day", outputFormat: "MMM d, yyyy" }
    }
  }

  connect() {
    const period = this.periodColumn()

    this.tabulatorTable = new DirectoryTable(this.tableTarget, {
      layout: "fitDataStretch",
      placeholder: emptyStatePlaceholder("No usage found"),
      ajaxURL: this.urlValue,
      columns:
      [
        { title: period.title, field: "period", formatter: "datetime", formatterParams: {
          inputFormat: "iso",
          outputFormat: period.outputFormat,
          timezone: "UTC",
        } },
        { 
          title: "Processes",
          field: "paperwork_processes_total",
          formatter: "money",
          formatterParams: { thousand: ",", precision: false }
        },
        // { 
        //   title: "Input total", 
        //   field: "usage_tokens_input",
        //   formatter: "money",
        //   formatterParams: { thousand: ",", precision: false }
        // },
        // { 
        //   title: "Output total", 
        //   field: "usage_tokens_output",
        //   formatter: "money",
        //   formatterParams: { thousand: ",", precision: false }
        // },
        { 
          title: "Total", 
          field: "usage_tokens_billed",
          formatter: "money",
          formatterParams: { thousand: ",", precision: false }
        },
      ],
      dependencies: {
        DateTime: DateTime,
      },  
    })
  }

  disconnect() {
    this.tabulatorTable?.destroy()
    this.tabulatorTable = null
  }
}
